<template>
  <div class="content">
    <el-card class="box-card contaier">
      <div class="title">
        <span class="perInfo">{{ $t("sidebar.recommend") }}</span>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$t('recommend.exhibition')" name="first"
          ><Exhibition :flag="flag1"
        /></el-tab-pane>
        <el-tab-pane :label="$t('recommend.exhibits')" name="second"
          ><Product :flag="flag2"
        /></el-tab-pane>
        <el-tab-pane :label="$t('recommend.live')" name="third"
          ><Live :flag="flag3"
        /></el-tab-pane>
        <el-tab-pane :label="$t('recommend.activity')" name="fourth"
          ><Activity :flag="flag4"
        /></el-tab-pane>
      </el-tabs>

      <!-- <div class="border"></div> -->
    </el-card>
  </div>
</template>
<script>
import Exhibition from "./components/exhibition.vue";
import Product from "./components/product.vue";
import Live from "./components/live.vue";
import Activity from "./components/activity.vue";
export default {
  data() {
    return {
      activeName: "second",
      tab: "",
      flag1: "",
      flag2: "",
      flag3: "",
      flag4: "",
      value: 0,
      tab: this.$route.query.tab,
    };
  },
  components: { Exhibition, Product, Live, Activity },
  created() {
    this.changeTab();
  },
  methods: {
    handleClick(tab) {
      this.tab = tab.name;
    },
    add() {
      this.value++;
      if (this.value > 1000) {
        this.value = 0;
      }
    },
    async changeContent() {
      // 切换页卡来筛选数据
      // this.tab可以知道当前点击的是哪个页卡
      if (this.activeName === "first") {
        // 展商换一批
        this.add();
        this.flag1 = "zs" + this.value;
      }
      if (this.activeName === "second") {
        // 展品换一批
        this.add();
        this.flag2 = "zp" + this.value;
      }
      if (this.activeName === "third") {
        // 直播换一批
        this.add();
        this.flag3 = "zb" + this.value;
      }
      if (this.activeName === "fourth") {
        // 活动换一批
        this.add();
        this.flag4 = "hd" + this.value;
      }
    },
    changeTab() {
      switch (this.tab) {
        case "1":
          this.activeName = "first";

          break;
        case "2":
          this.activeName = "second";

          break;
        case "3":
          this.activeName = "third";

          break;
        case "4":
          this.activeName = "fourth";

          break;
        default:
          this.activeName = "first";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.contaier {
  box-sizing: border-box;
  background: #f0f2f5;
  padding: 10px;
  padding-top: 60px;
  .title {
    display: flex;
    justify-content: flex-start;
    border-radius: 2px;
    position: relative;
    background-color: white;
    padding: 20px 15px 0px 15px;
    box-sizing: border-box;
    .perInfo {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #333333;
    }
  }
  .border {
    position: absolute;
    width: 100%;
    height: 1px;
    background: #e8e8e8;
    left: 0;
    top: 108px;
  }
}
</style>
<style scoped>
.el-tabs >>> .el-tabs__item.is-active {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #006fb8;
}
.el-tabs >>> .el-tabs__item:hover {
  color: #006fb8;
  cursor: pointer;
}
.el-tabs >>> .el-tabs__item {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}

.el-tabs >>> .el-tabs__nav-wrap::after {
  height: 1px;
  background: #e8e8e8;
}
.el-tabs >>> .el-tabs__nav-wrap::after:hover {
  color: #006fb8;
}
.el-tabs >>> .el-tabs__active-bar {
  height: 2px;
  background-color: #006fb8;
}
.content >>> .el-card__body {
  padding: 0px !important;
}
.content >>> .el-tabs__nav-wrap {
  background-color: white;
  padding: 0px 15px;
  box-sizing: border-box;
  padding-top: 20px;
}
</style>
